<div [formGroup]="formGroup">
  <yc-typeahead-select
    name="relatedComponent"
    [showClear]="false"
    [disabled]="isViewOnly"
    [items]="relatedComponentOptions"
    [label]="'common:textFormFieldSource' | ycI18n: 'Form field source'"
    (onChange)="onChange.emit($event)">
  </yc-typeahead-select>
</div>